import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TimerCleanupService } from "@core/services/timer-cleanup.service";
import { KeycloakService } from "@ogs/ngx-keycloak";

@Component({
  selector: "app-root",
  imports: [ RouterOutlet ],
  templateUrl: "./app-root.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppRootComponent implements OnInit {
  private readonly _keycloakService: KeycloakService = inject(KeycloakService);

  private readonly _cleanupService: TimerCleanupService = inject(TimerCleanupService);

  public ngOnInit (): void {
    this._keycloakService.startAccessTokenUpdate();
    this._cleanupService.cleanupExpiredTimers();
  }
}
